import template from './academy-course-track-report-card.component.html';
import controller from './academy-course-track-report-card.controller';

const academyCourseTrackReportCard = {
  bindings: {
    courseTrack: '<',
    user: '<',
  },
  template,
  controller,
};

export default academyCourseTrackReportCard;
